module.exports = __webpack_public_path__ + "img/undraw-ednpage.11b83883.png";